'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _flexBox = require('../../flex-box');

var _toolbar = require('../../toolbar');

var _toolbar2 = _interopRequireDefault(_toolbar);

var _carousel = require('../../carousel');

var _carousel2 = _interopRequireDefault(_carousel);

var _table = require('../table');

var _table2 = _interopRequireDefault(_table);

var _tile = require('../../tile');

var _tile2 = _interopRequireDefault(_tile);

var _withDevice = require('../../with-device');

var _withDevice2 = _interopRequireDefault(_withDevice);

require('../table.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function ProductTable(_ref) {
  var columns = _ref.columns,
      data = _ref.data,
      device = _ref.device,
      onCellSelection = _ref.onCellSelection,
      selectedColumns = _ref.selectedColumns,
      props = _objectWithoutProperties(_ref, ['columns', 'data', 'device', 'onCellSelection', 'selectedColumns']);

  var mobileColumns = columns.map(function (item) {
    return _extends({}, item);
  });
  var rowThColumn = mobileColumns.shift();

  if (device.isPhone) {
    return _react2.default.createElement(
      _carousel2.default,
      props,
      mobileColumns.map(function (column, i) {
        return _react2.default.createElement(
          'div',
          {
            key: column.accessor,
            className: 'product-table' + (selectedColumns.includes(i + 1) ? ' product-table--selected' : '')
          },
          _react2.default.createElement(
            _tile2.default,
            { border: 'none', padding: 'medium', className: 'table__head-tile' },
            column.header
          ),
          _react2.default.createElement(
            _flexBox.Flex,
            { gutter: 'small', margin: 'none' },
            data.map(function (cell) {
              return _react2.default.createElement(
                _react2.default.Fragment,
                { key: cell.accessor },
                _react2.default.createElement(
                  _flexBox.Box,
                  { xs: '8', flex: true, align: 'center', justify: 'flex-start' },
                  rowThColumn.render(cell[rowThColumn.accessor], cell, rowThColumn.accessor, i + 1)
                ),
                _react2.default.createElement(
                  _flexBox.Box,
                  { xs: '4', flex: true, align: 'center', justify: 'center' },
                  column.render(cell[column.accessor], cell, column.accessor, i + 1)
                )
              );
            })
          ),
          _react2.default.createElement(
            _toolbar2.default,
            { background: 'light', justify: 'center' },
            column.footer(i + 1)
          )
        );
      })
    );
  }

  return _react2.default.createElement(_table2.default, _extends({
    className: 'product-table',
    enableMobile: false,
    data: data,
    columns: columns,
    onCellSelection: onCellSelection,
    selectedColumns: selectedColumns
  }, props));
}

ProductTable.propTypes = {
  data: _propTypes2.default.array,
  columns: _propTypes2.default.array,
  onCellSelection: _propTypes2.default.func,
  selectedColumns: _propTypes2.default.array,
  device: _propTypes2.default.shape({
    isPhone: _propTypes2.default.bool.isRequired
  }).isRequired
};

exports.default = (0, _withDevice2.default)(ProductTable);